// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../../node_modules/postcss-loader/src/index.js!../../../../node_modules/sass-loader/dist/cjs.js!@css/utils");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._6Ls4jIhQx{max-width:350px;width:calc(100% - 40px);top:50%;left:50%;transform:translate(-50%, -50%);overflow:hidden}._29ngeQC1x{position:fixed}._4k6r3JZNx{}._6AIw5TUix{display:flex;justify-content:flex-end;margin-right:8px}._6AIw5TUix>*{margin-right:20px}._6AIw5TUix>*:last-child{margin-right:0}._6poW8z6cx{overflow:hidden;position:relative}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"dialog": "_6Ls4jIhQx",
	"backdrop": "_29ngeQC1x",
	"title": "_4k6r3JZNx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["wordwrap"] + "",
	"buttons": "_6AIw5TUix " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["space-xl-above"] + "",
	"no-scroll": "_6poW8z6cx",
	"noScroll": "_6poW8z6cx"
};
module.exports = exports;
